import React from 'react'
import { useTimeout } from '@mote/helpers'

export function useMemeTimeout(shouldShowMemeInitially) {
  const [showMeme, setShowMeme] = React.useState(shouldShowMemeInitially)

  useTimeout(
    () => {
      setShowMeme(false)
    },
    showMeme ? 2000 : null
  )

  return showMeme
}
